import { URL } from "../../utils/UrlConstants";
import { privateFetch } from "../../utils/CustomFetch.js";
import { properties } from "../../utils/Properties_es";
import { CONSTANT } from "../../utils/Constants";
import { RoleResponse } from "./RoleInterface";
import { UrlBase } from "../../url/Urls";

export const getRequest = async (company: string) : Promise<RoleResponse> => {
  try {
    const response = await privateFetch.get(URL.REQUEST_ROLE(company,UrlBase.registration_x_page));
    return response.data;
  } catch (error: any) {
    throw new Error(error);
  }
};


export const findByIdRequest = async (id:any) => {
  let responseData = {};
  await privateFetch
    .get(URL.REQUEST_ROLE(id,UrlBase.registration_x_page), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(properties.com_parval_label_role_findid_error);
    });
  return responseData;
};

export const findByIdRequestById = async (id:any) => {
  let responseData = {};
  await privateFetch
    .get(URL.REQUEST_ROLE_BY_ID(id), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(properties.com_parval_label_role_findid_error);
    });
  return responseData;
};

export const createRequest = async (data:any) => {
  let responseData = {};
  
  const requestBody = {
    id: data.id,
    name: data.name,
    description: data.description,
    adminLogin: true,
    clientLogin: true,
    companyId: data.companyId,
    userCreated: data.userCreated,
    notify: data.notify.id,
  };
  await privateFetch
    
    .post(URL.REQUEST_ROLE_CREATE, JSON.stringify(requestBody), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
   
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(properties.com_parval_label_role_save_error);
    });
  return responseData;
};

export const updateRequest = async (data:any) => {
  let responseData = {};  
  const requestBody = {
    id: data.id,
    name: data.name,
    description: data.description,
    adminLogin: data.adminLogin,
    clientLogin:data.clientLogin,
    companyId: data.companyId,
    userCreated: data.userCreated,
    userModified: data.userModified,
    notify: data.notify.id,
  };
  await privateFetch
    .put(URL.REQUEST_ROLE_UPDATE, JSON.stringify(requestBody),{
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(properties.com_parval_label_role_update_error);
    });
  return responseData;
};


export const deleteRequest = async (id:any) => {
  let responseData = {};
  await privateFetch
    .delete(URL.REQUEST_ROLE_DELETE(id), {})
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      //throw new Error(properties.com_parval_label_role_delete_error);
      console.log(error)
    });
  return responseData;
};
